import React from "react";
import { makeStyles } from "@material-ui/core";
import { KTextInput, KButton } from "@kyburz/kdesign-system";
import useSetState from "../../hooks/useSetState";
import { GroupData } from "../../interfaces/GroupInterface";
import GroupViewVehiclesTable from "./GroupViewVehiclesTable";
import SelectedItems from "./SelectedItems";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: "flex",
    marginTop: 16,
  },
}));

interface Props {
  groupData: GroupData;
  groupName: string;
  handleNameChange: (name: string) => void;
  handleCheckedIds: (name: string, ids: string[]) => void;
  vehicleIdsLength: number;
}

const GroupViewVehicles: React.FC<Props> = ({
  groupData,
  groupName,
  handleNameChange,
  handleCheckedIds,
  vehicleIdsLength,
}: Props) => {
  const classes = useStyles();
  const [{ filter, reset, vehiclesLength }, setState] = useSetState({
    filter: "all",
    reset: false,
    vehiclesLength: 0,
  });

  const handleFilterChange = (value: string): void => {
    setState({ filter: value, reset: true });
  };

  const handleReset = (): void => {
    setState({ reset: false });
  };

  const updateVehiclesLength = (length: number) => {
    setState({ vehiclesLength: length });
  };

  return (
    <div>
      <KTextInput
        label="Name"
        placeholder="Group name"
        value={groupName}
        onChange={(e) => handleNameChange(e.target.value)}
        required
      />
      <div className={classes.buttonContainer}>
        <KButton
          children="All"
          onClick={() => handleFilterChange("all")}
          style={{
            marginRight: 16,
            border:
              filter === "all" ? "1px solid #0066b3" : "1px solid #e2e2e2",
            color: filter === "all" ? "#0066b3" : "#383F51",
          }}
          theme="tertiary"
        />
        <KButton
          children="Incl."
          onClick={() => handleFilterChange("inkl")}
          style={{
            marginRight: 16,
            border:
              filter === "inkl" ? "1px solid #0066b3" : "1px solid #e2e2e2",
            color: filter === "inkl" ? "#0066b3" : "#383F51",
          }}
          theme="tertiary"
        />
        <KButton
          children="Not Incl."
          onClick={() => handleFilterChange("notInkl")}
          style={{
            marginRight: 16,
            border:
              filter === "notInkl" ? "1px solid #0066b3" : "1px solid #e2e2e2",
            color: filter === "notInkl" ? "#0066b3" : "#383F51",
          }}
          theme="tertiary"
        />
      </div>
      <SelectedItems
        wholeLength={vehiclesLength}
        selectedLength={vehicleIdsLength}
      />
      <GroupViewVehiclesTable
        groupData={groupData}
        activeFilter={filter}
        handleReset={handleReset}
        reset={reset}
        handleCheckedIds={handleCheckedIds}
        updateVehiclesLength={updateVehiclesLength}
      />
    </div>
  );
};

export default GroupViewVehicles;
